module.exports = __webpack_public_path__ + "img/psdUpload.0402ffff.png";